import { useAuth0 } from "@auth0/auth0-react";
import React, { useContext, useState } from "react";
import { PageContext } from "../../context/PageContext";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import { OrganisationContext, OrganisationSignalRContext } from "../../context/OrganisationContext";
import { useTheme } from "@mui/material";
import { ToastContext } from "../../context/ToastContext";
import { useLocalStorage } from "../../utils/localStorage";
import { ChasableSignalRContext } from "../../context/ChasablesContext";

const Profile = () => {
  const { showToast } = useContext(ToastContext);
  const theme = useTheme();
  const { logout, user } = useAuth0();
  const { setNewTitle } = useContext(PageContext);
  const { organisation } = useContext(OrganisationContext);
  const [isDarkMode, setIsDarkMode] = useState(theme.palette.mode === "dark");
  const storage = useLocalStorage();

  const clearStoredCompany = () => {
    storage?.removeItem(storage.keys.tenant);
    storage?.removeItem(storage.keys.userConfiguration);
  };

  React.useEffect(() => {
    setNewTitle("Profile");
  }, [setNewTitle]);

  const signOut = async () => {
    try {
      await Promise.all([ChasableSignalRContext.connection?.stop(), OrganisationSignalRContext.connection?.stop()]);
      await logout({ logoutParams: { returnTo: `${window.location.origin}/taskpane.html` } });
      clearStoredCompany();
    } catch (error) {
      console.error(error);
      showToast("Failed to sign out, please try again later", "error");
    }
  };

  const toggleColorMode = () => {
    setIsDarkMode(!isDarkMode);
    localStorage.setItem("theme", !isDarkMode ? "dark" : "light");
    showToast("Close and reopen the app to see the new theme", "success");
  };

  return (
    <>
      {user && (
        <Stack justifyContent="space-between" height="100%">
          <div style={{ textAlign: "center" }}>
            <Avatar src={user.picture} alt={user.name} sx={{ margin: "0 auto" }} />
            <Typography variant="h1" component="p" sx={{ lineHeight: "20px", marginTop: "15px" }}>
              {user.name}
            </Typography>
            <Typography variant="h2" component="p" sx={{ lineHeight: "20px", marginTop: "15px" }}>
              {organisation?.name ?? ""}
            </Typography>
            <Typography variant="h3" component="p">
              {user.email}
            </Typography>
          </div>
          <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} sx={{ my: 2 }}>
            <Button
              onClick={() => {
                const mode = theme.palette.mode === "light" ? "dark" : "light";
                toggleColorMode();
              }}
              sx={{
                minWidth: "auto",
                p: 1,
                borderRadius: "24px",
                backgroundColor: theme.palette.mode === "dark" ? "grey.200" : "grey.200",
              }}
            >
              {isDarkMode ? "🌙" : "☀️"}
              <Typography>Switch to {isDarkMode ? "light" : "dark"} mode</Typography>
            </Button>
          </Stack>
          <Button onClick={signOut} fullWidth={true} sx={{ marginBottom: "15px" }} variant="outlined">
            Sign out
          </Button>
        </Stack>
      )}
    </>
  );
};

export default Profile;
